import { httpService } from './HttpService'; 
import { Usuario } from '@/model/Usuario';

export class AuthService {
    private isAuth = false;

    login(usuario: string, password: string): Promise<any> {
        return new Promise((resolve) =>{
            httpService.post('security/login', {Usuario: usuario, Password: password })
            .then((res: any) => {
                if(res.Token){
                    httpService.token = res.Token;
                    localStorage.setItem("user", JSON.stringify(res.Usuario));
                    this.isAuth = true;
                }else{
                    this.isAuth = false;
                }
                resolve(this.isAuth);

            }).catch(error => { console.log(error); });
        });
    }

    logout(){
        httpService.token = "";
        localStorage.removeItem("user");
        this.isAuth = false;
    }

    isAuthenticated(){
        let user = <Usuario>JSON.parse(localStorage.getItem("user")+"");
        return httpService.token !== null && httpService.token !== "" && user !== null;
    }

    isAdmin(){
        let user = <Usuario> JSON.parse(localStorage.getItem("user")+"");
        return user !== null ? user.Rol === 99 : false;
    }

    getUser(){
        let user = <Usuario> JSON.parse(localStorage.getItem("user")+"");
        return user;
    }
}

export const authService = new AuthService();